<template>
  <v-sheet class="grey lighten-4" :class="mobile ? '' : 'pt-5'">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="10" class="pt-5">
        <div
          :class="mobile ? 'text-h4' : 'text-h3'"
          class="pa-2 text-center white--text mt-5 colorLogo--text outline font-weight-bold">
          Conheça as soluções que preparamos para você.
        </div>
        <div v-for="(feature, i) in features" :key="i" class="mt-5">
          <v-row align="center" justify="center">
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              align="center"
              v-if="!$vuetify.breakpoint.smAndDown">
              <v-img :src="feature.img" class="" max-width="600px" />
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" align="center">
              <v-img
                :src="feature.logo"
                class="mb-2"
                max-height="150px"
                :style="{
                  'max-width': $vuetify.breakpoint.smAndUp ? '50%' : '100%',
                }"
                contain
              />

              <div class="text-justify subtitle1 mt-5">
                {{ feature.text }}
              </div>
              <div class="d-flex justify-center mt-5">                
                <v-btn :href="feature.link" target="_blank" outlined 
                  >{{ feature.btn }}
                  <v-icon right>mdi-open-in-new</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          img: require("@/assets/products/malha-fina.png"),
          logo: require("@/assets/products/logo_malha_fina.png"),
          title: "Malha Fina do Contador",
          text: "Um Software desenvolvido exclusivamente para Contadores, que auxilia na Análises de Caixa das Declarações de Imposto de Renda de Pessoa Física. O Malha Fina do Contador agiliza a transmissão das Declarações, trazendo mais comodidade e assertividade,  através de um processo totalmente Automatizado, Em tempo Real, Seguro e Sem Limite de Análises.",
          link: "https://malhafina.cnt.br/#/",
          btn: "Conheça o Malha Fina",
        },
        {
          img: require("@/assets/products/tesys.png"),
          logo: require("@/assets/products/logo_tesys.png"),
          title: "Tesys",
          text: 'Uma Plataforma Completa, que irá trazer mais comodidade para suas tarefas e melhorar o relacionamento com seus clientes. O Tesys foi desenvolvido para trazer mais facilidade para o Dia a Dia, com ferramentas como: Controle de Caixa, Gestão de Documentos, Acompanhamento do processamento das Declarações e muito mais.',
          link: "https://tesys.com.br/",
          btn: "Conheça o Tesys",
        },
        {
          img: require("@/assets/products/econsenso.png"),
          logo: require("@/assets/products/logo_econsenso.png"),
          title: "eConsenso",
          text: "Uma Plataforma Online para a Solicitação e Registro de Consentimentos, seguindo as Diretrizes da Lei Geral de Proteção de Dados. Através da Plataforma a Empresa solicita Consentimentos, para o tratamento dos Dados, e os Cliente Aceitam, Recusam ou Reportam os Consentimento através do App eCONSENSO. É Mais Segurança e Menos Burocracia.",
          link: "https://econsenso.com.br/",
          btn: "Conheça o eCONSENSO",
        },
      ],
    };
  },
  computed: {
    mobile(){
      if (this.$vuetify.breakpoint.smAndDown) return true;
      return false;
    }
  }
};
</script>


<style scoped>
.break {
  word-break: break-word;
}
.title1 {
  font-size: 34px;
}
.subtitle1 {
  font-size: 19px;
}
</style>